module.exports = __webpack_public_path__ + "static/media/coinrepublic.9c77b175.png";